import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

export default function PaymentError() {
  const { t } = useTranslation();
  return (
    <main className="min-h-screen flex items-center justify-center px-4" data-testid="payment-error-page">
      <div className="w-full max-w-lg rounded-md border border-border bg-card p-8 text-center">
        <AlertTriangle className="w-10 h-10 text-verdict-fake mx-auto mb-4" />
        <h1 className="font-heading text-2xl font-bold mb-2">
          {t("payment.redirect.error.title", { defaultValue: "Pembayaran Gagal" })}
        </h1>
        <p className="text-sm text-muted-foreground">
          {t("payment.redirect.error.desc", {
            defaultValue: "Terjadi kendala saat memproses pembayaran Anda. Silakan coba lagi dari halaman paket.",
          })}
        </p>
        <div className="mt-6 flex items-center justify-center gap-2">
          <Link to="/pricing">
            <Button className="rounded-sm bg-brand-primary hover:bg-brand-primary/90 text-white">
              {t("nav.pricing")}
            </Button>
          </Link>
          <Link to="/dashboard">
            <Button variant="outline" className="rounded-sm">
              {t("payment.redirect.toDashboard", { defaultValue: "Buka Dashboard" })}
            </Button>
          </Link>
        </div>
      </div>
    </main>
  );
}

